import { Backdrop, Box, CircularProgress } from "@mui/material";
import PropTypes from "prop-types";

/**
 * 
 * @param {bool} isLoading  
 */

const CustomLoadingScreen = ({ isLoading }) => {
	return (
		<Box>
			<Backdrop
				sx={{
					color: "#fff",
					zIndex: (theme) => theme.zIndex.drawer + 1,
				}}
				open={isLoading}
			>
				<CircularProgress />
			</Backdrop>
		</Box>
	);
};

CustomLoadingScreen.propTypes = {
	isLoading: PropTypes.bool.isRequired,
};

export default CustomLoadingScreen;
